var Mr = Object.defineProperty;
var xr = (e, t, n) => t in e ? Mr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var $n = (e, t, n) => xr(e, typeof t != "symbol" ? t + "" : t, n);
import { defineComponent as K, computed as pe, openBlock as L, createElementBlock as V, createBlock as ne, resolveComponent as re, normalizeClass as Oe, createVNode as B, createElementVNode as z, renderSlot as ce, onUpdated as Vr, inject as Br, ref as Xe, onMounted as Wn, onBeforeUnmount as Fr, watch as Yn, provide as zr, resolveDynamicComponent as nn, withCtx as W, unref as H, Fragment as _e, renderList as Ze, toDisplayString as le, createTextVNode as Ie, normalizeStyle as Ur, createCommentVNode as De, TransitionGroup as Gr, withModifiers as $t, mergeProps as rn, toHandlers as jn, mergeModels as Hr, useModel as Wr, normalizeProps as Yr, guardReactiveProps as jr, Transition as Xr } from "vue";
import { DialogTitle as Kr, DialogDescription as qr, TransitionRoot as Dt, TransitionChild as Pt, Dialog as an, DialogPanel as Xn, Listbox as Zr, ListboxButton as Jr, ListboxOptions as Qr, ListboxOption as ea } from "@headlessui/vue";
const ta = ["alt", "width", "height", "srcset"], na = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGRgZAAAAAsAA8cA2jkAAAAASUVORK5CYII=", st = /* @__PURE__ */ K({
  __name: "ResponsiveImage",
  props: {
    image: {},
    alt: {}
  },
  setup(e) {
    const t = e, n = (a) => t.image.url.replace(/_\d+x\./, `_${Math.round(a)}x.`), r = pe(() => {
      var o;
      const a = Number(
        ((o = t.image.url.match(/_(\d+)x\./)) == null ? void 0 : o[1]) || t.image.width
      );
      return [
        `${n(a / 3)}`,
        `${n(a / 2)} 2x`,
        `${t.image.url} 3x`
      ].join(", ");
    });
    return (a, o) => (L(), V("img", {
      alt: a.alt || a.image.altText || "Oats Overnight",
      width: a.image.width,
      height: a.image.height,
      src: na,
      srcset: r.value
    }, null, 8, ta));
  }
}), zo = /* @__PURE__ */ K({
  __name: "BundleSelectionProduct",
  props: {
    product: {}
  },
  setup(e) {
    return (t, n) => (L(), ne(st, {
      image: t.product.featuredImage,
      alt: t.product.title,
      loading: "lazy",
      class: "w-24 h-24"
    }, null, 8, ["image", "alt"]));
  }
}), ra = {
  key: 0,
  class: "checkmark-callout-icon bg-green-400"
}, aa = {
  key: 1,
  class: "checkmark-callout-icon bg-neutral-400"
}, ia = ["innerHTML"], Uo = /* @__PURE__ */ K({
  __name: "CheckmarkCallout",
  props: {
    text: {},
    check: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, n) => {
      const r = re("SvgIcon");
      return L(), V("div", {
        class: Oe(["checkmark-callout flex items-center gap-1", { "text-neutral-400": !t.check }])
      }, [
        t.check ? (L(), V("div", ra, [
          B(r, {
            name: "check-callout",
            class: "h-full w-full"
          })
        ])) : (L(), V("div", aa, [
          B(r, {
            name: "cross-callout",
            class: "h-full w-full"
          })
        ])),
        z("span", { innerHTML: t.text }, null, 8, ia),
        ce(t.$slots, "default")
      ], 2);
    };
  }
});
function oa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function sa(e, t, n) {
  return oa(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
/*!
 * Splide.js
 * Version  : 4.1.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
var Cn = "(prefers-reduced-motion: reduce)", je = 1, ua = 2, Je = 3, tt = 4, gt = 5, wt = 6, Ct = 7, la = {
  CREATED: je,
  MOUNTED: ua,
  IDLE: Je,
  MOVING: tt,
  SCROLLING: gt,
  DRAGGING: wt,
  DESTROYED: Ct
};
function Le(e) {
  e.length = 0;
}
function Me(e, t, n) {
  return Array.prototype.slice.call(e, t, n);
}
function j(e) {
  return e.bind.apply(e, [null].concat(Me(arguments, 1)));
}
var Kn = setTimeout, qt = function() {
};
function Rn(e) {
  return requestAnimationFrame(e);
}
function kt(e, t) {
  return typeof t === e;
}
function ut(e) {
  return !sn(e) && kt("object", e);
}
var on = Array.isArray, qn = j(kt, "function"), Pe = j(kt, "string"), ht = j(kt, "undefined");
function sn(e) {
  return e === null;
}
function Zn(e) {
  try {
    return e instanceof (e.ownerDocument.defaultView || window).HTMLElement;
  } catch {
    return !1;
  }
}
function pt(e) {
  return on(e) ? e : [e];
}
function ve(e, t) {
  pt(e).forEach(t);
}
function un(e, t) {
  return e.indexOf(t) > -1;
}
function Tt(e, t) {
  return e.push.apply(e, pt(t)), e;
}
function Se(e, t, n) {
  e && ve(t, function(r) {
    r && e.classList[n ? "add" : "remove"](r);
  });
}
function Ee(e, t) {
  Se(e, Pe(t) ? t.split(" ") : t, !0);
}
function _t(e, t) {
  ve(t, e.appendChild.bind(e));
}
function ln(e, t) {
  ve(e, function(n) {
    var r = (t || n).parentNode;
    r && r.insertBefore(n, t);
  });
}
function lt(e, t) {
  return Zn(e) && (e.msMatchesSelector || e.matches).call(e, t);
}
function Jn(e, t) {
  var n = e ? Me(e.children) : [];
  return t ? n.filter(function(r) {
    return lt(r, t);
  }) : n;
}
function Et(e, t) {
  return t ? Jn(e, t)[0] : e.firstElementChild;
}
var ct = Object.keys;
function ze(e, t, n) {
  return e && (n ? ct(e).reverse() : ct(e)).forEach(function(r) {
    r !== "__proto__" && t(e[r], r);
  }), e;
}
function ft(e) {
  return Me(arguments, 1).forEach(function(t) {
    ze(t, function(n, r) {
      e[r] = t[r];
    });
  }), e;
}
function Ne(e) {
  return Me(arguments, 1).forEach(function(t) {
    ze(t, function(n, r) {
      on(n) ? e[r] = n.slice() : ut(n) ? e[r] = Ne({}, ut(e[r]) ? e[r] : {}, n) : e[r] = n;
    });
  }), e;
}
function Nn(e, t) {
  ve(t || ct(e), function(n) {
    delete e[n];
  });
}
function ye(e, t) {
  ve(e, function(n) {
    ve(t, function(r) {
      n && n.removeAttribute(r);
    });
  });
}
function x(e, t, n) {
  ut(t) ? ze(t, function(r, a) {
    x(e, a, r);
  }) : ve(e, function(r) {
    sn(n) || n === "" ? ye(r, t) : r.setAttribute(t, String(n));
  });
}
function Ke(e, t, n) {
  var r = document.createElement(e);
  return t && (Pe(t) ? Ee(r, t) : x(r, t)), n && _t(n, r), r;
}
function me(e, t, n) {
  if (ht(n))
    return getComputedStyle(e)[t];
  sn(n) || (e.style[t] = "" + n);
}
function dt(e, t) {
  me(e, "display", t);
}
function Qn(e) {
  e.setActive && e.setActive() || e.focus({
    preventScroll: !0
  });
}
function ge(e, t) {
  return e.getAttribute(t);
}
function On(e, t) {
  return e && e.classList.contains(t);
}
function fe(e) {
  return e.getBoundingClientRect();
}
function Ue(e) {
  ve(e, function(t) {
    t && t.parentNode && t.parentNode.removeChild(t);
  });
}
function er(e) {
  return Et(new DOMParser().parseFromString(e, "text/html").body);
}
function Ae(e, t) {
  e.preventDefault(), t && (e.stopPropagation(), e.stopImmediatePropagation());
}
function tr(e, t) {
  return e && e.querySelector(t);
}
function cn(e, t) {
  return t ? Me(e.querySelectorAll(t)) : [];
}
function we(e, t) {
  Se(e, t, !1);
}
function Zt(e) {
  return e.timeStamp;
}
function Fe(e) {
  return Pe(e) ? e : e ? e + "px" : "";
}
var yt = "splide", fn = "data-" + yt;
function it(e, t) {
  if (!e)
    throw new Error("[" + yt + "] " + (t || ""));
}
var ke = Math.min, Rt = Math.max, Nt = Math.floor, vt = Math.ceil, ue = Math.abs;
function nr(e, t, n) {
  return ue(e - t) < n;
}
function It(e, t, n, r) {
  var a = ke(t, n), o = Rt(t, n);
  return r ? a < e && e < o : a <= e && e <= o;
}
function We(e, t, n) {
  var r = ke(t, n), a = Rt(t, n);
  return ke(Rt(r, e), a);
}
function Jt(e) {
  return +(e > 0) - +(e < 0);
}
function Qt(e, t) {
  return ve(t, function(n) {
    e = e.replace("%s", "" + n);
  }), e;
}
function dn(e) {
  return e < 10 ? "0" + e : "" + e;
}
var Dn = {};
function ca(e) {
  return "" + e + dn(Dn[e] = (Dn[e] || 0) + 1);
}
function rr() {
  var e = [];
  function t(i, u, f, s) {
    a(i, u, function(l, _, m) {
      var h = "addEventListener" in l, c = h ? l.removeEventListener.bind(l, _, f, s) : l.removeListener.bind(l, f);
      h ? l.addEventListener(_, f, s) : l.addListener(f), e.push([l, _, m, f, c]);
    });
  }
  function n(i, u, f) {
    a(i, u, function(s, l, _) {
      e = e.filter(function(m) {
        return m[0] === s && m[1] === l && m[2] === _ && (!f || m[3] === f) ? (m[4](), !1) : !0;
      });
    });
  }
  function r(i, u, f) {
    var s, l = !0;
    return typeof CustomEvent == "function" ? s = new CustomEvent(u, {
      bubbles: l,
      detail: f
    }) : (s = document.createEvent("CustomEvent"), s.initCustomEvent(u, l, !1, f)), i.dispatchEvent(s), s;
  }
  function a(i, u, f) {
    ve(i, function(s) {
      s && ve(u, function(l) {
        l.split(" ").forEach(function(_) {
          var m = _.split(".");
          f(s, m[0], m[1]);
        });
      });
    });
  }
  function o() {
    e.forEach(function(i) {
      i[4]();
    }), Le(e);
  }
  return {
    bind: t,
    unbind: n,
    dispatch: r,
    destroy: o
  };
}
var xe = "mounted", Pn = "ready", $e = "move", nt = "moved", vn = "click", ar = "active", ir = "inactive", or = "visible", sr = "hidden", ee = "refresh", oe = "updated", Qe = "resize", Mt = "resized", ur = "drag", lr = "dragging", cr = "dragged", xt = "scroll", He = "scrolled", fa = "overflow", mn = "destroy", fr = "arrows:mounted", dr = "arrows:updated", vr = "pagination:mounted", mr = "pagination:updated", gn = "navigation:mounted", hn = "autoplay:play", gr = "autoplay:playing", pn = "autoplay:pause", _n = "lazyload:loaded", hr = "sk", pr = "sh", Ot = "ei";
function Z(e) {
  var t = e ? e.event.bus : document.createDocumentFragment(), n = rr();
  function r(o, i) {
    n.bind(t, pt(o).join(" "), function(u) {
      i.apply(i, on(u.detail) ? u.detail : []);
    });
  }
  function a(o) {
    n.dispatch(t, o, Me(arguments, 1));
  }
  return e && e.event.on(mn, n.destroy), ft(n, {
    bus: t,
    on: r,
    off: j(n.unbind, t),
    emit: a
  });
}
function Vt(e, t, n, r) {
  var a = Date.now, o, i = 0, u, f = !0, s = 0;
  function l() {
    if (!f) {
      if (i = e ? ke((a() - o) / e, 1) : 1, n && n(i), i >= 1 && (t(), o = a(), r && ++s >= r))
        return m();
      u = Rn(l);
    }
  }
  function _(E) {
    E || c(), o = a() - (E ? i * e : 0), f = !1, u = Rn(l);
  }
  function m() {
    f = !0;
  }
  function h() {
    o = a(), i = 0, n && n(i);
  }
  function c() {
    u && cancelAnimationFrame(u), i = 0, u = 0, f = !0;
  }
  function d(E) {
    e = E;
  }
  function g() {
    return f;
  }
  return {
    start: _,
    rewind: h,
    pause: m,
    cancel: c,
    set: d,
    isPaused: g
  };
}
function da(e) {
  var t = e;
  function n(a) {
    t = a;
  }
  function r(a) {
    return un(pt(a), t);
  }
  return {
    set: n,
    is: r
  };
}
function va(e, t) {
  var n = Vt(0, e, null, 1);
  return function() {
    n.isPaused() && n.start();
  };
}
function ma(e, t, n) {
  var r = e.state, a = n.breakpoints || {}, o = n.reducedMotion || {}, i = rr(), u = [];
  function f() {
    var c = n.mediaQuery === "min";
    ct(a).sort(function(d, g) {
      return c ? +d - +g : +g - +d;
    }).forEach(function(d) {
      l(a[d], "(" + (c ? "min" : "max") + "-width:" + d + "px)");
    }), l(o, Cn), _();
  }
  function s(c) {
    c && i.destroy();
  }
  function l(c, d) {
    var g = matchMedia(d);
    i.bind(g, "change", _), u.push([c, g]);
  }
  function _() {
    var c = r.is(Ct), d = n.direction, g = u.reduce(function(E, v) {
      return Ne(E, v[1].matches ? v[0] : {});
    }, {});
    Nn(n), h(g), n.destroy ? e.destroy(n.destroy === "completely") : c ? (s(!0), e.mount()) : d !== n.direction && e.refresh();
  }
  function m(c) {
    matchMedia(Cn).matches && (c ? Ne(n, o) : Nn(n, ct(o)));
  }
  function h(c, d, g) {
    Ne(n, c), d && Ne(Object.getPrototypeOf(n), c), (g || !r.is(je)) && e.emit(oe, n);
  }
  return {
    setup: f,
    destroy: s,
    reduce: m,
    set: h
  };
}
var Bt = "Arrow", Ft = Bt + "Left", zt = Bt + "Right", _r = Bt + "Up", Er = Bt + "Down", kn = "rtl", Ut = "ttb", Yt = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [_r, zt],
  ArrowRight: [Er, Ft]
};
function ga(e, t, n) {
  function r(o, i, u) {
    u = u || n.direction;
    var f = u === kn && !i ? 1 : u === Ut ? 0 : -1;
    return Yt[o] && Yt[o][f] || o.replace(/width|left|right/i, function(s, l) {
      var _ = Yt[s.toLowerCase()][f] || s;
      return l > 0 ? _.charAt(0).toUpperCase() + _.slice(1) : _;
    });
  }
  function a(o) {
    return o * (n.direction === kn ? 1 : -1);
  }
  return {
    resolve: r,
    orient: a
  };
}
var Te = "role", qe = "tabindex", ha = "disabled", he = "aria-", bt = he + "controls", yr = he + "current", Mn = he + "selected", de = he + "label", En = he + "labelledby", br = he + "hidden", yn = he + "orientation", mt = he + "roledescription", xn = he + "live", Vn = he + "busy", Bn = he + "atomic", bn = [Te, qe, ha, bt, yr, de, En, br, yn, mt], be = yt + "__", Ve = "is-", jt = yt, Fn = be + "track", pa = be + "list", Gt = be + "slide", Ar = Gt + "--clone", _a = Gt + "__container", An = be + "arrows", Ht = be + "arrow", Sr = Ht + "--prev", wr = Ht + "--next", Wt = be + "pagination", Tr = Wt + "__page", Ea = be + "progress", ya = Ea + "__bar", ba = be + "toggle", Aa = be + "spinner", Sa = be + "sr", wa = Ve + "initialized", Ge = Ve + "active", Ir = Ve + "prev", Lr = Ve + "next", en = Ve + "visible", tn = Ve + "loading", $r = Ve + "focus-in", Cr = Ve + "overflow", Ta = [Ge, en, Ir, Lr, tn, $r, Cr], Ia = {
  slide: Gt,
  clone: Ar,
  arrows: An,
  arrow: Ht,
  prev: Sr,
  next: wr,
  pagination: Wt,
  page: Tr,
  spinner: Aa
};
function La(e, t) {
  if (qn(e.closest))
    return e.closest(t);
  for (var n = e; n && n.nodeType === 1 && !lt(n, t); )
    n = n.parentElement;
  return n;
}
var $a = 5, zn = 200, Rr = "touchstart mousedown", Xt = "touchmove mousemove", Kt = "touchend touchcancel mouseup click";
function Ca(e, t, n) {
  var r = Z(e), a = r.on, o = r.bind, i = e.root, u = n.i18n, f = {}, s = [], l = [], _ = [], m, h, c;
  function d() {
    p(), D(), v();
  }
  function g() {
    a(ee, E), a(ee, d), a(oe, v), o(document, Rr + " keydown", function(b) {
      c = b.type === "keydown";
    }, {
      capture: !0
    }), o(i, "focusin", function() {
      Se(i, $r, !!c);
    });
  }
  function E(b) {
    var C = bn.concat("style");
    Le(s), we(i, l), we(m, _), ye([m, h], C), ye(i, b ? C : ["style", mt]);
  }
  function v() {
    we(i, l), we(m, _), l = k(jt), _ = k(Fn), Ee(i, l), Ee(m, _), x(i, de, n.label), x(i, En, n.labelledby);
  }
  function p() {
    m = $("." + Fn), h = Et(m, "." + pa), it(m && h, "A track/list element is missing."), Tt(s, Jn(h, "." + Gt + ":not(." + Ar + ")")), ze({
      arrows: An,
      pagination: Wt,
      prev: Sr,
      next: wr,
      bar: ya,
      toggle: ba
    }, function(b, C) {
      f[C] = $("." + b);
    }), ft(f, {
      root: i,
      track: m,
      list: h,
      slides: s
    });
  }
  function D() {
    var b = i.id || ca(yt), C = n.role;
    i.id = b, m.id = m.id || b + "-track", h.id = h.id || b + "-list", !ge(i, Te) && i.tagName !== "SECTION" && C && x(i, Te, C), x(i, mt, u.carousel), x(h, Te, "presentation");
  }
  function $(b) {
    var C = tr(i, b);
    return C && La(C, "." + jt) === i ? C : void 0;
  }
  function k(b) {
    return [b + "--" + n.type, b + "--" + n.direction, n.drag && b + "--draggable", n.isNavigation && b + "--nav", b === jt && Ge];
  }
  return ft(f, {
    setup: d,
    mount: g,
    destroy: E
  });
}
var et = "slide", rt = "loop", At = "fade";
function Ra(e, t, n, r) {
  var a = Z(e), o = a.on, i = a.emit, u = a.bind, f = e.Components, s = e.root, l = e.options, _ = l.isNavigation, m = l.updateOnMove, h = l.i18n, c = l.pagination, d = l.slideFocus, g = f.Direction.resolve, E = ge(r, "style"), v = ge(r, de), p = n > -1, D = Et(r, "." + _a), $;
  function k() {
    p || (r.id = s.id + "-slide" + dn(t + 1), x(r, Te, c ? "tabpanel" : "group"), x(r, mt, h.slide), x(r, de, v || Qt(h.slideLabel, [t + 1, e.length]))), b();
  }
  function b() {
    u(r, "click", j(i, vn, P)), u(r, "keydown", j(i, hr, P)), o([nt, pr, He], S), o(gn, U), m && o($e, O);
  }
  function C() {
    $ = !0, a.destroy(), we(r, Ta), ye(r, bn), x(r, "style", E), x(r, de, v || "");
  }
  function U() {
    var N = e.splides.map(function(A) {
      var R = A.splide.Components.Slides.getAt(t);
      return R ? R.slide.id : "";
    }).join(" ");
    x(r, de, Qt(h.slideX, (p ? n : t) + 1)), x(r, bt, N), x(r, Te, d ? "button" : ""), d && ye(r, mt);
  }
  function O() {
    $ || S();
  }
  function S() {
    if (!$) {
      var N = e.index;
      w(), T(), Se(r, Ir, t === N - 1), Se(r, Lr, t === N + 1);
    }
  }
  function w() {
    var N = F();
    N !== On(r, Ge) && (Se(r, Ge, N), x(r, yr, _ && N || ""), i(N ? ar : ir, P));
  }
  function T() {
    var N = J(), A = !N && (!F() || p);
    if (e.state.is([tt, gt]) || x(r, br, A || ""), x(cn(r, l.focusableNodes || ""), qe, A ? -1 : ""), d && x(r, qe, A ? -1 : 0), N !== On(r, en) && (Se(r, en, N), i(N ? or : sr, P)), !N && document.activeElement === r) {
      var R = f.Slides.getAt(e.index);
      R && Qn(R.slide);
    }
  }
  function M(N, A, R) {
    me(R && D || r, N, A);
  }
  function F() {
    var N = e.index;
    return N === t || l.cloneStatus && N === n;
  }
  function J() {
    if (e.is(At))
      return F();
    var N = fe(f.Elements.track), A = fe(r), R = g("left", !0), G = g("right", !0);
    return Nt(N[R]) <= vt(A[R]) && Nt(A[G]) <= vt(N[G]);
  }
  function q(N, A) {
    var R = ue(N - t);
    return !p && (l.rewind || e.is(rt)) && (R = ke(R, e.length - R)), R <= A;
  }
  var P = {
    index: t,
    slideIndex: n,
    slide: r,
    container: D,
    isClone: p,
    mount: k,
    destroy: C,
    update: S,
    style: M,
    isWithin: q
  };
  return P;
}
function Na(e, t, n) {
  var r = Z(e), a = r.on, o = r.emit, i = r.bind, u = t.Elements, f = u.slides, s = u.list, l = [];
  function _() {
    m(), a(ee, h), a(ee, m);
  }
  function m() {
    f.forEach(function(S, w) {
      d(S, w, -1);
    });
  }
  function h() {
    $(function(S) {
      S.destroy();
    }), Le(l);
  }
  function c() {
    $(function(S) {
      S.update();
    });
  }
  function d(S, w, T) {
    var M = Ra(e, w, T, S);
    M.mount(), l.push(M), l.sort(function(F, J) {
      return F.index - J.index;
    });
  }
  function g(S) {
    return S ? k(function(w) {
      return !w.isClone;
    }) : l;
  }
  function E(S) {
    var w = t.Controller, T = w.toIndex(S), M = w.hasFocus() ? 1 : n.perPage;
    return k(function(F) {
      return It(F.index, T, T + M - 1);
    });
  }
  function v(S) {
    return k(S)[0];
  }
  function p(S, w) {
    ve(S, function(T) {
      if (Pe(T) && (T = er(T)), Zn(T)) {
        var M = f[w];
        M ? ln(T, M) : _t(s, T), Ee(T, n.classes.slide), C(T, j(o, Qe));
      }
    }), o(ee);
  }
  function D(S) {
    Ue(k(S).map(function(w) {
      return w.slide;
    })), o(ee);
  }
  function $(S, w) {
    g(w).forEach(S);
  }
  function k(S) {
    return l.filter(qn(S) ? S : function(w) {
      return Pe(S) ? lt(w.slide, S) : un(pt(S), w.index);
    });
  }
  function b(S, w, T) {
    $(function(M) {
      M.style(S, w, T);
    });
  }
  function C(S, w) {
    var T = cn(S, "img"), M = T.length;
    M ? T.forEach(function(F) {
      i(F, "load error", function() {
        --M || w();
      });
    }) : w();
  }
  function U(S) {
    return S ? f.length : l.length;
  }
  function O() {
    return l.length > n.perPage;
  }
  return {
    mount: _,
    destroy: h,
    update: c,
    register: d,
    get: g,
    getIn: E,
    getAt: v,
    add: p,
    remove: D,
    forEach: $,
    filter: k,
    style: b,
    getLength: U,
    isEnough: O
  };
}
function Oa(e, t, n) {
  var r = Z(e), a = r.on, o = r.bind, i = r.emit, u = t.Slides, f = t.Direction.resolve, s = t.Elements, l = s.root, _ = s.track, m = s.list, h = u.getAt, c = u.style, d, g, E;
  function v() {
    p(), o(window, "resize load", va(j(i, Qe))), a([oe, ee], p), a(Qe, D);
  }
  function p() {
    d = n.direction === Ut, me(l, "maxWidth", Fe(n.width)), me(_, f("paddingLeft"), $(!1)), me(_, f("paddingRight"), $(!0)), D(!0);
  }
  function D(P) {
    var N = fe(l);
    (P || g.width !== N.width || g.height !== N.height) && (me(_, "height", k()), c(f("marginRight"), Fe(n.gap)), c("width", C()), c("height", U(), !0), g = N, i(Mt), E !== (E = q()) && (Se(l, Cr, E), i(fa, E)));
  }
  function $(P) {
    var N = n.padding, A = f(P ? "right" : "left");
    return N && Fe(N[A] || (ut(N) ? 0 : N)) || "0px";
  }
  function k() {
    var P = "";
    return d && (P = b(), it(P, "height or heightRatio is missing."), P = "calc(" + P + " - " + $(!1) + " - " + $(!0) + ")"), P;
  }
  function b() {
    return Fe(n.height || fe(m).width * n.heightRatio);
  }
  function C() {
    return n.autoWidth ? null : Fe(n.fixedWidth) || (d ? "" : O());
  }
  function U() {
    return Fe(n.fixedHeight) || (d ? n.autoHeight ? null : O() : b());
  }
  function O() {
    var P = Fe(n.gap);
    return "calc((100%" + (P && " + " + P) + ")/" + (n.perPage || 1) + (P && " - " + P) + ")";
  }
  function S() {
    return fe(m)[f("width")];
  }
  function w(P, N) {
    var A = h(P || 0);
    return A ? fe(A.slide)[f("width")] + (N ? 0 : F()) : 0;
  }
  function T(P, N) {
    var A = h(P);
    if (A) {
      var R = fe(A.slide)[f("right")], G = fe(m)[f("left")];
      return ue(R - G) + (N ? 0 : F());
    }
    return 0;
  }
  function M(P) {
    return T(e.length - 1) - T(0) + w(0, P);
  }
  function F() {
    var P = h(0);
    return P && parseFloat(me(P.slide, f("marginRight"))) || 0;
  }
  function J(P) {
    return parseFloat(me(_, f("padding" + (P ? "Right" : "Left")))) || 0;
  }
  function q() {
    return e.is(At) || M(!0) > S();
  }
  return {
    mount: v,
    resize: D,
    listSize: S,
    slideSize: w,
    sliderSize: M,
    totalSize: T,
    getPadding: J,
    isOverflow: q
  };
}
var Da = 2;
function Pa(e, t, n) {
  var r = Z(e), a = r.on, o = t.Elements, i = t.Slides, u = t.Direction.resolve, f = [], s;
  function l() {
    a(ee, _), a([oe, Qe], h), (s = g()) && (c(s), t.Layout.resize(!0));
  }
  function _() {
    m(), l();
  }
  function m() {
    Ue(f), Le(f), r.destroy();
  }
  function h() {
    var E = g();
    s !== E && (s < E || !E) && r.emit(ee);
  }
  function c(E) {
    var v = i.get().slice(), p = v.length;
    if (p) {
      for (; v.length < E; )
        Tt(v, v);
      Tt(v.slice(-E), v.slice(0, E)).forEach(function(D, $) {
        var k = $ < E, b = d(D.slide, $);
        k ? ln(b, v[0].slide) : _t(o.list, b), Tt(f, b), i.register(b, $ - E + (k ? 0 : p), D.index);
      });
    }
  }
  function d(E, v) {
    var p = E.cloneNode(!0);
    return Ee(p, n.classes.clone), p.id = e.root.id + "-clone" + dn(v + 1), p;
  }
  function g() {
    var E = n.clones;
    if (!e.is(rt))
      E = 0;
    else if (ht(E)) {
      var v = n[u("fixedWidth")] && t.Layout.slideSize(0), p = v && vt(fe(o.track)[u("width")] / v);
      E = p || n[u("autoWidth")] && e.length || n.perPage * Da;
    }
    return E;
  }
  return {
    mount: l,
    destroy: m
  };
}
function ka(e, t, n) {
  var r = Z(e), a = r.on, o = r.emit, i = e.state.set, u = t.Layout, f = u.slideSize, s = u.getPadding, l = u.totalSize, _ = u.listSize, m = u.sliderSize, h = t.Direction, c = h.resolve, d = h.orient, g = t.Elements, E = g.list, v = g.track, p;
  function D() {
    p = t.Transition, a([xe, Mt, oe, ee], $);
  }
  function $() {
    t.Controller.isBusy() || (t.Scroll.cancel(), b(e.index), t.Slides.update());
  }
  function k(A, R, G, ae) {
    A !== R && P(A > G) && (S(), C(O(M(), A > G), !0)), i(tt), o($e, R, G, A), p.start(R, function() {
      i(Je), o(nt, R, G, A), ae && ae();
    });
  }
  function b(A) {
    C(T(A, !0));
  }
  function C(A, R) {
    if (!e.is(At)) {
      var G = R ? A : U(A);
      me(E, "transform", "translate" + c("X") + "(" + G + "px)"), A !== G && o(pr);
    }
  }
  function U(A) {
    if (e.is(rt)) {
      var R = w(A), G = R > t.Controller.getEnd(), ae = R < 0;
      (ae || G) && (A = O(A, G));
    }
    return A;
  }
  function O(A, R) {
    var G = A - q(R), ae = m();
    return A -= d(ae * (vt(ue(G) / ae) || 1)) * (R ? 1 : -1), A;
  }
  function S() {
    C(M(), !0), p.cancel();
  }
  function w(A) {
    for (var R = t.Slides.get(), G = 0, ae = 1 / 0, te = 0; te < R.length; te++) {
      var Re = R[te].index, y = ue(T(Re, !0) - A);
      if (y <= ae)
        ae = y, G = Re;
      else
        break;
    }
    return G;
  }
  function T(A, R) {
    var G = d(l(A - 1) - J(A));
    return R ? F(G) : G;
  }
  function M() {
    var A = c("left");
    return fe(E)[A] - fe(v)[A] + d(s(!1));
  }
  function F(A) {
    return n.trimSpace && e.is(et) && (A = We(A, 0, d(m(!0) - _()))), A;
  }
  function J(A) {
    var R = n.focus;
    return R === "center" ? (_() - f(A, !0)) / 2 : +R * f(A) || 0;
  }
  function q(A) {
    return T(A ? t.Controller.getEnd() : 0, !!n.trimSpace);
  }
  function P(A) {
    var R = d(O(M(), A));
    return A ? R >= 0 : R <= E[c("scrollWidth")] - fe(v)[c("width")];
  }
  function N(A, R) {
    R = ht(R) ? M() : R;
    var G = A !== !0 && d(R) < d(q(!1)), ae = A !== !1 && d(R) > d(q(!0));
    return G || ae;
  }
  return {
    mount: D,
    move: k,
    jump: b,
    translate: C,
    shift: O,
    cancel: S,
    toIndex: w,
    toPosition: T,
    getPosition: M,
    getLimit: q,
    exceededLimit: N,
    reposition: $
  };
}
function Ma(e, t, n) {
  var r = Z(e), a = r.on, o = r.emit, i = t.Move, u = i.getPosition, f = i.getLimit, s = i.toPosition, l = t.Slides, _ = l.isEnough, m = l.getLength, h = n.omitEnd, c = e.is(rt), d = e.is(et), g = j(M, !1), E = j(M, !0), v = n.start || 0, p, D = v, $, k, b;
  function C() {
    U(), a([oe, ee, Ot], U), a(Mt, O);
  }
  function U() {
    $ = m(!0), k = n.perMove, b = n.perPage, p = P();
    var y = We(v, 0, h ? p : $ - 1);
    y !== v && (v = y, i.reposition());
  }
  function O() {
    p !== P() && o(Ot);
  }
  function S(y, Y, se) {
    if (!Re()) {
      var Q = T(y), ie = q(Q);
      ie > -1 && (Y || ie !== v) && (G(ie), i.move(Q, ie, D, se));
    }
  }
  function w(y, Y, se, Q) {
    t.Scroll.scroll(y, Y, se, function() {
      var ie = q(i.toIndex(u()));
      G(h ? ke(ie, p) : ie), Q && Q();
    });
  }
  function T(y) {
    var Y = v;
    if (Pe(y)) {
      var se = y.match(/([+\-<>])(\d+)?/) || [], Q = se[1], ie = se[2];
      Q === "+" || Q === "-" ? Y = F(v + +("" + Q + (+ie || 1)), v) : Q === ">" ? Y = ie ? N(+ie) : g(!0) : Q === "<" && (Y = E(!0));
    } else
      Y = c ? y : We(y, 0, p);
    return Y;
  }
  function M(y, Y) {
    var se = k || (te() ? 1 : b), Q = F(v + se * (y ? -1 : 1), v, !(k || te()));
    return Q === -1 && d && !nr(u(), f(!y), 1) ? y ? 0 : p : Y ? Q : q(Q);
  }
  function F(y, Y, se) {
    if (_() || te()) {
      var Q = J(y);
      Q !== y && (Y = y, y = Q, se = !1), y < 0 || y > p ? !k && (It(0, y, Y, !0) || It(p, Y, y, !0)) ? y = N(A(y)) : c ? y = se ? y < 0 ? -($ % b || b) : $ : y : n.rewind ? y = y < 0 ? p : 0 : y = -1 : se && y !== Y && (y = N(A(Y) + (y < Y ? -1 : 1)));
    } else
      y = -1;
    return y;
  }
  function J(y) {
    if (d && n.trimSpace === "move" && y !== v)
      for (var Y = u(); Y === s(y, !0) && It(y, 0, e.length - 1, !n.rewind); )
        y < v ? --y : ++y;
    return y;
  }
  function q(y) {
    return c ? (y + $) % $ || 0 : y;
  }
  function P() {
    for (var y = $ - (te() || c && k ? 1 : b); h && y-- > 0; )
      if (s($ - 1, !0) !== s(y, !0)) {
        y++;
        break;
      }
    return We(y, 0, $ - 1);
  }
  function N(y) {
    return We(te() ? y : b * y, 0, p);
  }
  function A(y) {
    return te() ? ke(y, p) : Nt((y >= p ? $ - 1 : y) / b);
  }
  function R(y) {
    var Y = i.toIndex(y);
    return d ? We(Y, 0, p) : Y;
  }
  function G(y) {
    y !== v && (D = v, v = y);
  }
  function ae(y) {
    return y ? D : v;
  }
  function te() {
    return !ht(n.focus) || n.isNavigation;
  }
  function Re() {
    return e.state.is([tt, gt]) && !!n.waitForTransition;
  }
  return {
    mount: C,
    go: S,
    scroll: w,
    getNext: g,
    getPrev: E,
    getAdjacent: M,
    getEnd: P,
    setIndex: G,
    getIndex: ae,
    toIndex: N,
    toPage: A,
    toDest: R,
    hasFocus: te,
    isBusy: Re
  };
}
var xa = "http://www.w3.org/2000/svg", Va = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z", St = 40;
function Ba(e, t, n) {
  var r = Z(e), a = r.on, o = r.bind, i = r.emit, u = n.classes, f = n.i18n, s = t.Elements, l = t.Controller, _ = s.arrows, m = s.track, h = _, c = s.prev, d = s.next, g, E, v = {};
  function p() {
    $(), a(oe, D);
  }
  function D() {
    k(), p();
  }
  function $() {
    var w = n.arrows;
    w && !(c && d) && U(), c && d && (ft(v, {
      prev: c,
      next: d
    }), dt(h, w ? "" : "none"), Ee(h, E = An + "--" + n.direction), w && (b(), S(), x([c, d], bt, m.id), i(fr, c, d)));
  }
  function k() {
    r.destroy(), we(h, E), g ? (Ue(_ ? [c, d] : h), c = d = null) : ye([c, d], bn);
  }
  function b() {
    a([xe, nt, ee, He, Ot], S), o(d, "click", j(C, ">")), o(c, "click", j(C, "<"));
  }
  function C(w) {
    l.go(w, !0);
  }
  function U() {
    h = _ || Ke("div", u.arrows), c = O(!0), d = O(!1), g = !0, _t(h, [c, d]), !_ && ln(h, m);
  }
  function O(w) {
    var T = '<button class="' + u.arrow + " " + (w ? u.prev : u.next) + '" type="button"><svg xmlns="' + xa + '" viewBox="0 0 ' + St + " " + St + '" width="' + St + '" height="' + St + '" focusable="false"><path d="' + (n.arrowPath || Va) + '" />';
    return er(T);
  }
  function S() {
    if (c && d) {
      var w = e.index, T = l.getPrev(), M = l.getNext(), F = T > -1 && w < T ? f.last : f.prev, J = M > -1 && w > M ? f.first : f.next;
      c.disabled = T < 0, d.disabled = M < 0, x(c, de, F), x(d, de, J), i(dr, c, d, T, M);
    }
  }
  return {
    arrows: v,
    mount: p,
    destroy: k,
    update: S
  };
}
var Fa = fn + "-interval";
function za(e, t, n) {
  var r = Z(e), a = r.on, o = r.bind, i = r.emit, u = Vt(n.interval, e.go.bind(e, ">"), b), f = u.isPaused, s = t.Elements, l = t.Elements, _ = l.root, m = l.toggle, h = n.autoplay, c, d, g = h === "pause";
  function E() {
    h && (v(), m && x(m, bt, s.track.id), g || p(), k());
  }
  function v() {
    n.pauseOnHover && o(_, "mouseenter mouseleave", function(U) {
      c = U.type === "mouseenter", $();
    }), n.pauseOnFocus && o(_, "focusin focusout", function(U) {
      d = U.type === "focusin", $();
    }), m && o(m, "click", function() {
      g ? p() : D(!0);
    }), a([$e, xt, ee], u.rewind), a($e, C);
  }
  function p() {
    f() && t.Slides.isEnough() && (u.start(!n.resetProgress), d = c = g = !1, k(), i(hn));
  }
  function D(U) {
    U === void 0 && (U = !0), g = !!U, k(), f() || (u.pause(), i(pn));
  }
  function $() {
    g || (c || d ? D(!1) : p());
  }
  function k() {
    m && (Se(m, Ge, !g), x(m, de, n.i18n[g ? "play" : "pause"]));
  }
  function b(U) {
    var O = s.bar;
    O && me(O, "width", U * 100 + "%"), i(gr, U);
  }
  function C(U) {
    var O = t.Slides.getAt(U);
    u.set(O && +ge(O.slide, Fa) || n.interval);
  }
  return {
    mount: E,
    destroy: u.cancel,
    play: p,
    pause: D,
    isPaused: f
  };
}
function Ua(e, t, n) {
  var r = Z(e), a = r.on;
  function o() {
    n.cover && (a(_n, j(u, !0)), a([xe, oe, ee], j(i, !0)));
  }
  function i(f) {
    t.Slides.forEach(function(s) {
      var l = Et(s.container || s.slide, "img");
      l && l.src && u(f, l, s);
    });
  }
  function u(f, s, l) {
    l.style("background", f ? 'center/cover no-repeat url("' + s.src + '")' : "", !0), dt(s, f ? "none" : "");
  }
  return {
    mount: o,
    destroy: j(i, !1)
  };
}
var Ga = 10, Ha = 600, Wa = 0.6, Ya = 1.5, ja = 800;
function Xa(e, t, n) {
  var r = Z(e), a = r.on, o = r.emit, i = e.state.set, u = t.Move, f = u.getPosition, s = u.getLimit, l = u.exceededLimit, _ = u.translate, m = e.is(et), h, c, d = 1;
  function g() {
    a($e, D), a([oe, ee], $);
  }
  function E(b, C, U, O, S) {
    var w = f();
    if (D(), U && (!m || !l())) {
      var T = t.Layout.sliderSize(), M = Jt(b) * T * Nt(ue(b) / T) || 0;
      b = u.toPosition(t.Controller.toDest(b % T)) + M;
    }
    var F = nr(w, b, 1);
    d = 1, C = F ? 0 : C || Rt(ue(b - w) / Ya, ja), c = O, h = Vt(C, v, j(p, w, b, S), 1), i(gt), o(xt), h.start();
  }
  function v() {
    i(Je), c && c(), o(He);
  }
  function p(b, C, U, O) {
    var S = f(), w = b + (C - b) * k(O), T = (w - S) * d;
    _(S + T), m && !U && l() && (d *= Wa, ue(T) < Ga && E(s(l(!0)), Ha, !1, c, !0));
  }
  function D() {
    h && h.cancel();
  }
  function $() {
    h && !h.isPaused() && (D(), v());
  }
  function k(b) {
    var C = n.easingFunc;
    return C ? C(b) : 1 - Math.pow(1 - b, 4);
  }
  return {
    mount: g,
    destroy: D,
    scroll: E,
    cancel: $
  };
}
var Ye = {
  passive: !1,
  capture: !0
};
function Ka(e, t, n) {
  var r = Z(e), a = r.on, o = r.emit, i = r.bind, u = r.unbind, f = e.state, s = t.Move, l = t.Scroll, _ = t.Controller, m = t.Elements.track, h = t.Media.reduce, c = t.Direction, d = c.resolve, g = c.orient, E = s.getPosition, v = s.exceededLimit, p, D, $, k, b, C = !1, U, O, S;
  function w() {
    i(m, Xt, qt, Ye), i(m, Kt, qt, Ye), i(m, Rr, M, Ye), i(m, "click", q, {
      capture: !0
    }), i(m, "dragstart", Ae), a([xe, oe], T);
  }
  function T() {
    var I = n.drag;
    Ln(!I), k = I === "free";
  }
  function M(I) {
    if (U = !1, !O) {
      var X = ie(I);
      Q(I.target) && (X || !I.button) && (_.isBusy() ? Ae(I, !0) : (S = X ? m : window, b = f.is([tt, gt]), $ = null, i(S, Xt, F, Ye), i(S, Kt, J, Ye), s.cancel(), l.cancel(), P(I)));
    }
  }
  function F(I) {
    if (f.is(wt) || (f.set(wt), o(ur)), I.cancelable)
      if (b) {
        s.translate(p + se(te(I)));
        var X = Re(I) > zn, Be = C !== (C = v());
        (X || Be) && P(I), U = !0, o(lr), Ae(I);
      } else R(I) && (b = A(I), Ae(I));
  }
  function J(I) {
    f.is(wt) && (f.set(Je), o(cr)), b && (N(I), Ae(I)), u(S, Xt, F), u(S, Kt, J), b = !1;
  }
  function q(I) {
    !O && U && Ae(I, !0);
  }
  function P(I) {
    $ = D, D = I, p = E();
  }
  function N(I) {
    var X = G(I), Be = ae(X), at = n.rewind && n.rewindByDrag;
    h(!1), k ? _.scroll(Be, 0, n.snap) : e.is(At) ? _.go(g(Jt(X)) < 0 ? at ? "<" : "-" : at ? ">" : "+") : e.is(et) && C && at ? _.go(v(!0) ? ">" : "<") : _.go(_.toDest(Be), !0), h(!0);
  }
  function A(I) {
    var X = n.dragMinThreshold, Be = ut(X), at = Be && X.mouse || 0, kr = (Be ? X.touch : +X) || 10;
    return ue(te(I)) > (ie(I) ? kr : at);
  }
  function R(I) {
    return ue(te(I)) > ue(te(I, !0));
  }
  function G(I) {
    if (e.is(rt) || !C) {
      var X = Re(I);
      if (X && X < zn)
        return te(I) / X;
    }
    return 0;
  }
  function ae(I) {
    return E() + Jt(I) * ke(ue(I) * (n.flickPower || 600), k ? 1 / 0 : t.Layout.listSize() * (n.flickMaxPages || 1));
  }
  function te(I, X) {
    return Y(I, X) - Y(y(I), X);
  }
  function Re(I) {
    return Zt(I) - Zt(y(I));
  }
  function y(I) {
    return D === I && $ || D;
  }
  function Y(I, X) {
    return (ie(I) ? I.changedTouches[0] : I)["page" + d(X ? "Y" : "X")];
  }
  function se(I) {
    return I / (C && e.is(et) ? $a : 1);
  }
  function Q(I) {
    var X = n.noDrag;
    return !lt(I, "." + Tr + ", ." + Ht) && (!X || !lt(I, X));
  }
  function ie(I) {
    return typeof TouchEvent < "u" && I instanceof TouchEvent;
  }
  function Pr() {
    return b;
  }
  function Ln(I) {
    O = I;
  }
  return {
    mount: w,
    disable: Ln,
    isDragging: Pr
  };
}
var qa = {
  Spacebar: " ",
  Right: zt,
  Left: Ft,
  Up: _r,
  Down: Er
};
function Sn(e) {
  return e = Pe(e) ? e : e.key, qa[e] || e;
}
var Un = "keydown";
function Za(e, t, n) {
  var r = Z(e), a = r.on, o = r.bind, i = r.unbind, u = e.root, f = t.Direction.resolve, s, l;
  function _() {
    m(), a(oe, h), a(oe, m), a($e, d);
  }
  function m() {
    var E = n.keyboard;
    E && (s = E === "global" ? window : u, o(s, Un, g));
  }
  function h() {
    i(s, Un);
  }
  function c(E) {
    l = E;
  }
  function d() {
    var E = l;
    l = !0, Kn(function() {
      l = E;
    });
  }
  function g(E) {
    if (!l) {
      var v = Sn(E);
      v === f(Ft) ? e.go("<") : v === f(zt) && e.go(">");
    }
  }
  return {
    mount: _,
    destroy: h,
    disable: c
  };
}
var ot = fn + "-lazy", Lt = ot + "-srcset", Ja = "[" + ot + "], [" + Lt + "]";
function Qa(e, t, n) {
  var r = Z(e), a = r.on, o = r.off, i = r.bind, u = r.emit, f = n.lazyLoad === "sequential", s = [nt, He], l = [];
  function _() {
    n.lazyLoad && (m(), a(ee, m));
  }
  function m() {
    Le(l), h(), f ? E() : (o(s), a(s, c), c());
  }
  function h() {
    t.Slides.forEach(function(v) {
      cn(v.slide, Ja).forEach(function(p) {
        var D = ge(p, ot), $ = ge(p, Lt);
        if (D !== p.src || $ !== p.srcset) {
          var k = n.classes.spinner, b = p.parentElement, C = Et(b, "." + k) || Ke("span", k, b);
          l.push([p, v, C]), p.src || dt(p, "none");
        }
      });
    });
  }
  function c() {
    l = l.filter(function(v) {
      var p = n.perPage * ((n.preloadPages || 1) + 1) - 1;
      return v[1].isWithin(e.index, p) ? d(v) : !0;
    }), l.length || o(s);
  }
  function d(v) {
    var p = v[0];
    Ee(v[1].slide, tn), i(p, "load error", j(g, v)), x(p, "src", ge(p, ot)), x(p, "srcset", ge(p, Lt)), ye(p, ot), ye(p, Lt);
  }
  function g(v, p) {
    var D = v[0], $ = v[1];
    we($.slide, tn), p.type !== "error" && (Ue(v[2]), dt(D, ""), u(_n, D, $), u(Qe)), f && E();
  }
  function E() {
    l.length && d(l.shift());
  }
  return {
    mount: _,
    destroy: j(Le, l),
    check: c
  };
}
function ei(e, t, n) {
  var r = Z(e), a = r.on, o = r.emit, i = r.bind, u = t.Slides, f = t.Elements, s = t.Controller, l = s.hasFocus, _ = s.getIndex, m = s.go, h = t.Direction.resolve, c = f.pagination, d = [], g, E;
  function v() {
    p(), a([oe, ee, Ot], v);
    var O = n.pagination;
    c && dt(c, O ? "" : "none"), O && (a([$e, xt, He], U), D(), U(), o(vr, {
      list: g,
      items: d
    }, C(e.index)));
  }
  function p() {
    g && (Ue(c ? Me(g.children) : g), we(g, E), Le(d), g = null), r.destroy();
  }
  function D() {
    var O = e.length, S = n.classes, w = n.i18n, T = n.perPage, M = l() ? s.getEnd() + 1 : vt(O / T);
    g = c || Ke("ul", S.pagination, f.track.parentElement), Ee(g, E = Wt + "--" + b()), x(g, Te, "tablist"), x(g, de, w.select), x(g, yn, b() === Ut ? "vertical" : "");
    for (var F = 0; F < M; F++) {
      var J = Ke("li", null, g), q = Ke("button", {
        class: S.page,
        type: "button"
      }, J), P = u.getIn(F).map(function(A) {
        return A.slide.id;
      }), N = !l() && T > 1 ? w.pageX : w.slideX;
      i(q, "click", j($, F)), n.paginationKeyboard && i(q, "keydown", j(k, F)), x(J, Te, "presentation"), x(q, Te, "tab"), x(q, bt, P.join(" ")), x(q, de, Qt(N, F + 1)), x(q, qe, -1), d.push({
        li: J,
        button: q,
        page: F
      });
    }
  }
  function $(O) {
    m(">" + O, !0);
  }
  function k(O, S) {
    var w = d.length, T = Sn(S), M = b(), F = -1;
    T === h(zt, !1, M) ? F = ++O % w : T === h(Ft, !1, M) ? F = (--O + w) % w : T === "Home" ? F = 0 : T === "End" && (F = w - 1);
    var J = d[F];
    J && (Qn(J.button), m(">" + F), Ae(S, !0));
  }
  function b() {
    return n.paginationDirection || n.direction;
  }
  function C(O) {
    return d[s.toPage(O)];
  }
  function U() {
    var O = C(_(!0)), S = C(_());
    if (O) {
      var w = O.button;
      we(w, Ge), ye(w, Mn), x(w, qe, -1);
    }
    if (S) {
      var T = S.button;
      Ee(T, Ge), x(T, Mn, !0), x(T, qe, "");
    }
    o(mr, {
      list: g,
      items: d
    }, O, S);
  }
  return {
    items: d,
    mount: v,
    destroy: p,
    getAt: C,
    update: U
  };
}
var ti = [" ", "Enter"];
function ni(e, t, n) {
  var r = n.isNavigation, a = n.slideFocus, o = [];
  function i() {
    e.splides.forEach(function(c) {
      c.isParent || (s(e, c.splide), s(c.splide, e));
    }), r && l();
  }
  function u() {
    o.forEach(function(c) {
      c.destroy();
    }), Le(o);
  }
  function f() {
    u(), i();
  }
  function s(c, d) {
    var g = Z(c);
    g.on($e, function(E, v, p) {
      d.go(d.is(rt) ? p : E);
    }), o.push(g);
  }
  function l() {
    var c = Z(e), d = c.on;
    d(vn, m), d(hr, h), d([xe, oe], _), o.push(c), c.emit(gn, e.splides);
  }
  function _() {
    x(t.Elements.list, yn, n.direction === Ut ? "vertical" : "");
  }
  function m(c) {
    e.go(c.index);
  }
  function h(c, d) {
    un(ti, Sn(d)) && (m(c), Ae(d));
  }
  return {
    setup: j(t.Media.set, {
      slideFocus: ht(a) ? r : a
    }, !0),
    mount: i,
    destroy: u,
    remount: f
  };
}
function ri(e, t, n) {
  var r = Z(e), a = r.bind, o = 0;
  function i() {
    n.wheel && a(t.Elements.track, "wheel", u, Ye);
  }
  function u(s) {
    if (s.cancelable) {
      var l = s.deltaY, _ = l < 0, m = Zt(s), h = n.wheelMinThreshold || 0, c = n.wheelSleep || 0;
      ue(l) > h && m - o > c && (e.go(_ ? "<" : ">"), o = m), f(_) && Ae(s);
    }
  }
  function f(s) {
    return !n.releaseWheel || e.state.is(tt) || t.Controller.getAdjacent(s) !== -1;
  }
  return {
    mount: i
  };
}
var ai = 90;
function ii(e, t, n) {
  var r = Z(e), a = r.on, o = t.Elements.track, i = n.live && !n.isNavigation, u = Ke("span", Sa), f = Vt(ai, j(l, !1));
  function s() {
    i && (m(!t.Autoplay.isPaused()), x(o, Bn, !0), u.textContent = "…", a(hn, j(m, !0)), a(pn, j(m, !1)), a([nt, He], j(l, !0)));
  }
  function l(h) {
    x(o, Vn, h), h ? (_t(o, u), f.start()) : (Ue(u), f.cancel());
  }
  function _() {
    ye(o, [xn, Bn, Vn]), Ue(u);
  }
  function m(h) {
    i && x(o, xn, h ? "off" : "polite");
  }
  return {
    mount: s,
    disable: m,
    destroy: _
  };
}
var oi = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media: ma,
  Direction: ga,
  Elements: Ca,
  Slides: Na,
  Layout: Oa,
  Clones: Pa,
  Move: ka,
  Controller: Ma,
  Arrows: Ba,
  Autoplay: za,
  Cover: Ua,
  Scroll: Xa,
  Drag: Ka,
  Keyboard: Za,
  LazyLoad: Qa,
  Pagination: ei,
  Sync: ni,
  Wheel: ri,
  Live: ii
}), si = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
}, ui = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: !0,
  arrows: !0,
  pagination: !0,
  paginationKeyboard: !0,
  interval: 5e3,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  resetProgress: !0,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: !0,
  direction: "ltr",
  trimSpace: !0,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: !0,
  classes: Ia,
  i18n: si,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function li(e, t, n) {
  var r = t.Slides;
  function a() {
    Z(e).on([xe, ee], o);
  }
  function o() {
    r.forEach(function(u) {
      u.style("transform", "translateX(-" + 100 * u.index + "%)");
    });
  }
  function i(u, f) {
    r.style("transition", "opacity " + n.speed + "ms " + n.easing), Kn(f);
  }
  return {
    mount: a,
    start: i,
    cancel: qt
  };
}
function ci(e, t, n) {
  var r = t.Move, a = t.Controller, o = t.Scroll, i = t.Elements.list, u = j(me, i, "transition"), f;
  function s() {
    Z(e).bind(i, "transitionend", function(h) {
      h.target === i && f && (_(), f());
    });
  }
  function l(h, c) {
    var d = r.toPosition(h, !0), g = r.getPosition(), E = m(h);
    ue(d - g) >= 1 && E >= 1 ? n.useScroll ? o.scroll(d, E, !1, c) : (u("transform " + E + "ms " + n.easing), r.translate(d, !0), f = c) : (r.jump(h), c());
  }
  function _() {
    u(""), o.cancel();
  }
  function m(h) {
    var c = n.rewindSpeed;
    if (e.is(et) && c) {
      var d = a.getIndex(!0), g = a.getEnd();
      if (d === 0 && h >= g || d >= g && h === 0)
        return c;
    }
    return n.speed;
  }
  return {
    mount: s,
    start: l,
    cancel: _
  };
}
var fi = /* @__PURE__ */ function() {
  function e(n, r) {
    this.event = Z(), this.Components = {}, this.state = da(je), this.splides = [], this._o = {}, this._E = {};
    var a = Pe(n) ? tr(document, n) : n;
    it(a, a + " is invalid."), this.root = a, r = Ne({
      label: ge(a, de) || "",
      labelledby: ge(a, En) || ""
    }, ui, e.defaults, r || {});
    try {
      Ne(r, JSON.parse(ge(a, fn)));
    } catch {
      it(!1, "Invalid JSON");
    }
    this._o = Object.create(Ne({}, r));
  }
  var t = e.prototype;
  return t.mount = function(r, a) {
    var o = this, i = this.state, u = this.Components;
    it(i.is([je, Ct]), "Already mounted!"), i.set(je), this._C = u, this._T = a || this._T || (this.is(At) ? li : ci), this._E = r || this._E;
    var f = ft({}, oi, this._E, {
      Transition: this._T
    });
    return ze(f, function(s, l) {
      var _ = s(o, u, o._o);
      u[l] = _, _.setup && _.setup();
    }), ze(u, function(s) {
      s.mount && s.mount();
    }), this.emit(xe), Ee(this.root, wa), i.set(Je), this.emit(Pn), this;
  }, t.sync = function(r) {
    return this.splides.push({
      splide: r
    }), r.splides.push({
      splide: this,
      isParent: !0
    }), this.state.is(Je) && (this._C.Sync.remount(), r.Components.Sync.remount()), this;
  }, t.go = function(r) {
    return this._C.Controller.go(r), this;
  }, t.on = function(r, a) {
    return this.event.on(r, a), this;
  }, t.off = function(r) {
    return this.event.off(r), this;
  }, t.emit = function(r) {
    var a;
    return (a = this.event).emit.apply(a, [r].concat(Me(arguments, 1))), this;
  }, t.add = function(r, a) {
    return this._C.Slides.add(r, a), this;
  }, t.remove = function(r) {
    return this._C.Slides.remove(r), this;
  }, t.is = function(r) {
    return this._o.type === r;
  }, t.refresh = function() {
    return this.emit(ee), this;
  }, t.destroy = function(r) {
    r === void 0 && (r = !0);
    var a = this.event, o = this.state;
    return o.is(je) ? Z(this).on(Pn, this.destroy.bind(this, r)) : (ze(this._C, function(i) {
      i.destroy && i.destroy(r);
    }, !0), a.emit(mn), a.destroy(), r && Le(this.splides), o.set(Ct)), this;
  }, sa(e, [{
    key: "options",
    get: function() {
      return this._o;
    },
    set: function(r) {
      this._C.Media.set(r, !0, !0);
    }
  }, {
    key: "length",
    get: function() {
      return this._C.Slides.getLength(!0);
    }
  }, {
    key: "index",
    get: function() {
      return this._C.Controller.getIndex();
    }
  }]), e;
}(), wn = fi;
wn.defaults = {};
wn.STATES = la;
const Gn = [
  ar,
  fr,
  dr,
  pn,
  hn,
  gr,
  vn,
  mn,
  ur,
  cr,
  lr,
  sr,
  ir,
  _n,
  xe,
  $e,
  nt,
  gn,
  vr,
  mr,
  ee,
  Qe,
  Mt,
  xt,
  He,
  oe,
  or
], Nr = "splide";
function Hn(e) {
  return e !== null && typeof e == "object";
}
function di(e, t) {
  if (e) {
    const n = Object.keys(e);
    for (let r = 0; r < n.length; r++) {
      const a = n[r];
      if (a !== "__proto__" && t(e[a], a) === !1)
        break;
    }
  }
  return e;
}
function Or(e, t) {
  const n = e;
  return di(t, (r, a) => {
    Array.isArray(r) ? n[a] = r.slice() : Hn(r) ? n[a] = Or(Hn(n[a]) ? n[a] : {}, r) : n[a] = r;
  }), n;
}
const vi = K({
  name: "SplideTrack",
  setup() {
    Vr(() => {
      var e;
      const t = Br(Nr);
      (e = t == null ? void 0 : t.value) == null || e.refresh();
    });
  }
}), Tn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, a] of t)
    n[r] = a;
  return n;
}, mi = { class: "splide__track" }, gi = { class: "splide__list" };
function hi(e, t, n, r, a, o) {
  return L(), V("div", mi, [
    z("ul", gi, [
      ce(e.$slots, "default")
    ])
  ]);
}
const pi = /* @__PURE__ */ Tn(vi, [["render", hi]]), _i = K({
  name: "Splide",
  emits: Gn.map((e) => `splide:${e}`),
  components: { SplideTrack: pi },
  props: {
    tag: {
      default: "div",
      type: String
    },
    options: {
      default: {},
      type: Object
    },
    extensions: Object,
    transition: Function,
    hasTrack: {
      default: !0,
      type: Boolean
    }
  },
  setup(e, t) {
    const n = Xe(), r = Xe();
    Wn(() => {
      r.value && (n.value = new wn(r.value, e.options), f(n.value), n.value.mount(e.extensions, e.transition));
    }), Fr(() => {
      var s;
      (s = n.value) == null || s.destroy();
    }), Yn(() => Or({}, e.options), (s) => {
      n.value && (n.value.options = s);
    }, { deep: !0 }), zr(Nr, n);
    const a = pe(() => {
      var s;
      return ((s = n.value) == null ? void 0 : s.index) || 0;
    }), o = pe(() => {
      var s;
      return ((s = n.value) == null ? void 0 : s.length) || 0;
    });
    function i(s) {
      var l;
      (l = n.value) == null || l.go(s);
    }
    function u(s) {
      var l;
      (l = n.value) == null || l.sync(s);
    }
    function f(s) {
      Gn.forEach((l) => {
        s.on(l, (..._) => {
          t.emit(`splide:${l}`, s, ..._);
        });
      });
    }
    return {
      splide: n,
      root: r,
      index: a,
      length: o,
      go: i,
      sync: u
    };
  }
});
function Ei(e, t, n, r, a, o) {
  const i = re("SplideTrack");
  return L(), ne(nn(e.tag), {
    class: "splide",
    ref: "root"
  }, {
    default: W(() => [
      e.hasTrack ? (L(), ne(i, { key: 0 }, {
        default: W(() => [
          ce(e.$slots, "default")
        ]),
        _: 3
      })) : ce(e.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 512);
}
const yi = /* @__PURE__ */ Tn(_i, [["render", Ei]]), bi = K({
  name: "SplideSlide"
}), Ai = { class: "splide__slide" };
function Si(e, t, n, r, a, o) {
  return L(), V("li", Ai, [
    ce(e.$slots, "default")
  ]);
}
const wi = /* @__PURE__ */ Tn(bi, [["render", Si]]), Ti = { class: "overflow-hidden" }, Go = /* @__PURE__ */ K({
  __name: "ImageSlider",
  props: {
    images: {},
    defaultAltText: {}
  },
  setup(e) {
    const t = e, n = Xe(), r = {
      progress: !0,
      autoplay: !0,
      rewind: !0,
      pagination: !0
    }, a = (o) => typeof o == "string" && o.length ? o : t.defaultAltText;
    return Yn(
      () => t.images,
      () => {
        var o;
        return (o = n.value) == null ? void 0 : o.go(0);
      }
    ), (o, i) => (L(), V("div", Ti, [
      o.images.length === 1 ? (L(), ne(st, {
        key: 0,
        image: o.images[0],
        alt: a(o.images[0].altText)
      }, null, 8, ["image", "alt"])) : (L(), ne(H(yi), {
        key: 1,
        ref_key: "splide",
        ref: n,
        options: r,
        "aria-label": "Images",
        class: "pagination-dots"
      }, {
        default: W(() => [
          (L(!0), V(_e, null, Ze(o.images, (u) => (L(), ne(H(wi), {
            key: u.id
          }, {
            default: W(() => [
              B(st, {
                image: u,
                alt: a(u.altText)
              }, null, 8, ["image", "alt"])
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 512))
    ]));
  }
}), Ce = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, a] of t)
    n[r] = a;
  return n;
}, Ii = {}, Li = {
  "data-testid": "section-loader",
  class: "flex items-center justify-center p-5"
};
function $i(e, t) {
  const n = re("SvgIcon");
  return L(), V("div", Li, [
    B(n, {
      name: "loader",
      class: "animate-spin w-10 h-10 text-purple-100"
    })
  ]);
}
const Ci = /* @__PURE__ */ Ce(Ii, [["render", $i]]), Ri = {
  class: "block",
  "aria-hidden": "true"
}, Ni = ["href"], Oi = /* @__PURE__ */ K({
  __name: "SvgIcon",
  props: {
    name: {}
  },
  setup(e) {
    const t = e, n = pe(() => `#icon-${t.name}`);
    return (r, a) => (L(), V("svg", Ri, [
      z("use", {
        href: n.value,
        fill: "currentColor"
      }, null, 8, Ni)
    ]));
  }
}), Di = {}, Pi = { class: "toast z-50 font-normal absolute flex gap-2 items-center px-4 py-8 bg-white text-black border-2 border-blue-300 rounded-2xl shadow-toast" };
function ki(e, t) {
  return L(), V("button", Pi, [
    ce(e.$slots, "default")
  ]);
}
const Ho = /* @__PURE__ */ Ce(Di, [["render", ki]]), Wo = /* @__PURE__ */ K({
  __name: "OrderStatusTag",
  props: {
    order: {}
  },
  setup(e) {
    return (t, n) => (L(), V("span", {
      class: Oe(["tag", [
        t.order.deliveredAt && "+green",
        t.order.status === "Refunded" && "+yellow",
        t.order.status === "Cancelled" && "+red"
      ]])
    }, le(t.order.status), 3));
  }
}), Mi = {}, xi = { class: "new-flavor-tag" };
function Vi(e, t) {
  const n = re("SvgIcon");
  return L(), V("div", xi, [
    B(n, {
      name: "new-flavor",
      class: "h-3 w-3"
    }),
    t[0] || (t[0] = Ie(" New "))
  ]);
}
const Yo = /* @__PURE__ */ Ce(Mi, [["render", Vi]]), jo = /* @__PURE__ */ K({
  __name: "ProductRatingImage",
  props: {
    product: {}
  },
  setup(e) {
    return (t, n) => (L(), V(_e, null, [
      B(st, {
        class: "w-20 h-20 mb-6 z-10",
        image: t.product.featuredImage,
        alt: t.product.title
      }, null, 8, ["image", "alt"]),
      n[0] || (n[0] = z("div", { class: "rounded-full bg-green-400 p-8 absolute translate-y-1.5 translate-x-2" }, null, -1))
    ], 64));
  }
}), Bi = {
  all: "All",
  "fruit-flavor": "Fruit",
  caffeinated: "Caffeinated",
  vegan: "Vegan",
  "whey-protein": "Whey",
  "subscribers-only": "Subscribers Only"
}, Fi = { class: "product-tag-icons flex items-end" }, zi = { class: "relative flex items-center flex-col-reverse text-gray-600 py-1 px-2 w-6 h-6" }, Ui = ["aria-label"], Gi = { class: "product-tag-label whitespace-nowrap hidden absolute top-0 bottom-0 z-0 py-0.5 text-white text-sm capitalize pointer-events-none peer-hover:bg-gray-800/90 peer-hover:block" }, Xo = /* @__PURE__ */ K({
  __name: "ProductTagIcons",
  props: {
    tags: {}
  },
  setup(e) {
    const t = e, n = Object.fromEntries(
      Object.entries(Bi).filter(([r]) => t.tags.includes(r))
    );
    return (r, a) => {
      const o = re("SvgIcon");
      return L(), V("div", Fi, [
        (L(!0), V(_e, null, Ze(H(n), (i, u, f) => (L(), V("div", {
          key: u,
          style: Ur({ "z-index": 10 - f }),
          class: "relative cursor-pointer"
        }, [
          z("div", zi, [
            z("button", {
              class: "peer flex-center w-7 h-7 z-10 hover:text-white",
              "aria-label": `tag ${i}`,
              "data-gtm-action": "show tag"
            }, [
              B(o, {
                name: `filter-${u}`,
                class: "h-4 w-4"
              }, null, 8, ["name"])
            ], 8, Ui),
            z("div", Gi, [
              z("div", null, le(i), 1)
            ])
          ])
        ], 4))), 128))
      ]);
    };
  }
}), Hi = { class: "text-xl font-bold! sm:text-2xl" }, Wi = { class: "flex gap-2" }, Yi = {
  key: 0,
  class: "mr-2 relative"
}, ji = { class: "grow min-w-[220px]" }, Ko = /* @__PURE__ */ K({
  __name: "ProductNutritionModal",
  props: {
    product: {}
  },
  setup(e) {
    var r;
    const t = e, n = ((r = t.product.nutrition) == null ? void 0 : r.value) || t.product.title;
    return (a, o) => {
      const i = re("ResponsiveImage");
      return L(), V(_e, null, [
        B(H(Kr), null, {
          default: W(() => [
            z("h2", Hi, le(a.product.title), 1)
          ]),
          _: 1
        }),
        B(H(qr), null, {
          default: W(() => [
            z("div", Wi, [
              a.product.nutritionFlavorForwardImage ? (L(), V("div", Yi, [
                B(i, {
                  class: "w-full h-full object-cover bg-gray-50 rounded-bl-xl min-w-[45px] lg:min-w-[220px]",
                  image: a.product.nutritionFlavorForwardImage,
                  alt: a.product.title,
                  loading: "lazy",
                  tabindex: "0"
                }, null, 8, ["image", "alt"])
              ])) : De("", !0),
              z("div", ji, [
                a.product.nutritionImage ? (L(), ne(i, {
                  key: 0,
                  class: "w-64",
                  image: a.product.nutritionImage,
                  alt: H(n),
                  loading: "lazy",
                  tabindex: "0"
                }, null, 8, ["image", "alt"])) : De("", !0),
                o[0] || (o[0] = z("p", { class: "mt-2 text-gray-800 text-xs text-left font-semibold uppercase leading-4" }, " DOES NOT CONTAIN ERYTHRITOL. ", -1))
              ])
            ])
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), Xi = ["data-product-id"], Ki = { class: "flex items-center justify-center py-16" }, qo = /* @__PURE__ */ K({
  __name: "ProductReviewsModal",
  props: {
    product: {}
  },
  emits: ["close"],
  setup(e) {
    return (t, n) => {
      const r = re("DialogTitle"), a = re("SectionLoader"), o = re("DialogDescription");
      return L(), V(_e, null, [
        B(r, null, {
          default: W(() => [
            Ie(le(t.product.title) + " Reviews ", 1)
          ]),
          _: 1
        }),
        B(o, null, {
          default: W(() => [
            z("div", {
              class: "junip-product-review",
              "data-product-id": t.product.nid
            }, [
              z("div", Ki, [
                B(a)
              ])
            ], 8, Xi)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), qi = {
  type: "button",
  class: "button"
}, Zo = /* @__PURE__ */ K({
  __name: "Button",
  props: {
    label: {}
  },
  setup(e) {
    return (t, n) => (L(), V("button", qi, [
      ce(t.$slots, "default", {}, () => [
        Ie(le(t.label), 1)
      ])
    ]));
  }
}), Zi = {}, Ji = {
  class: "flex-center rounded-full bg-white p-1",
  "data-gtm-action": "close",
  "aria-label": "close"
};
function Qi(e, t) {
  const n = re("SvgIcon");
  return L(), V("button", Ji, [
    B(n, {
      name: "close",
      class: "w-5 h-5"
    })
  ]);
}
const Dr = /* @__PURE__ */ Ce(Zi, [["render", Qi]]), eo = { class: "button disclosure-button" }, to = { class: "grow" }, no = { class: "disclosure flex-center rounded-full text-white px-4 py-1 text-sm w-14" }, ro = /* @__PURE__ */ K({
  __name: "DisclosureButton",
  props: {
    label: {},
    disclosure: {}
  },
  setup(e) {
    return (t, n) => (L(), V("button", eo, [
      z("div", to, [
        ce(t.$slots, "default", {}, () => [
          Ie(le(t.label), 1)
        ], !0)
      ]),
      z("div", no, [
        ce(t.$slots, "disclosure", {}, () => [
          Ie(le(t.disclosure), 1)
        ], !0)
      ])
    ]));
  }
}), Jo = /* @__PURE__ */ Ce(ro, [["__scopeId", "data-v-b6f73a4c"]]), ao = ["disabled"], io = {
  key: "success",
  class: "flex-center gap-2"
}, oo = {
  key: "loader",
  class: "mr-2"
}, so = { key: "content" }, uo = /* @__PURE__ */ K({
  __name: "LoaderButton",
  props: {
    loading: { type: Boolean },
    success: { type: Boolean }
  },
  setup(e) {
    return (t, n) => {
      const r = re("SvgIcon");
      return L(), V("button", {
        disabled: t.loading,
        class: Oe(["loader-button", t.$attrs.class || "button"])
      }, [
        B(Gr, { name: "loader-button" }, {
          default: W(() => [
            t.success ? (L(), V("div", io, [
              B(r, {
                name: "check",
                class: "w-4 h-4"
              }),
              ce(t.$slots, "success", {}, () => [
                n[0] || (n[0] = Ie(" Saved "))
              ])
            ])) : (L(), V(_e, { key: 1 }, [
              t.loading ? (L(), V("div", oo, [
                B(r, {
                  name: "loader",
                  class: "animate-spin w-6 h-6"
                })
              ])) : De("", !0),
              z("div", so, [
                ce(t.$slots, "default", {}, () => [
                  n[1] || (n[1] = Ie(" Save "))
                ])
              ])
            ], 64))
          ]),
          _: 3
        })
      ], 10, ao);
    };
  }
}), lo = {}, co = { class: "flex-center gap-1 cursor-pointer text-green-500" };
function fo(e, t) {
  const n = re("SvgIcon");
  return L(), V("button", co, [
    B(n, {
      name: "trash",
      class: "h-4 w-4"
    }),
    t[0] || (t[0] = z("span", { class: "underline text-sm" }, " Remove ", -1))
  ]);
}
const Qo = /* @__PURE__ */ Ce(lo, [["render", fo]]), In = /* @__PURE__ */ K({
  __name: "DialogOverlay",
  props: {
    visible: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (L(), ne(H(Dt), { show: t.visible }, {
      default: W(() => [
        B(H(Pt), {
          as: "template",
          enter: "duration-300 ease-out",
          "enter-from": "opacity-0",
          "enter-to": "motion-reduce:transition-none opacity-300",
          leave: "duration-100 ease-in",
          "leave-from": "opacity-100",
          "leave-to": "motion-reduce:transition-none opacity-0",
          show: t.visible
        }, {
          default: W(() => n[0] || (n[0] = [
            z("div", {
              class: "fixed inset-0 bg-black/50",
              "aria-hidden": "true"
            }, null, -1)
          ])),
          _: 1
        }, 8, ["show"])
      ]),
      _: 1
    }, 8, ["show"]));
  }
}), vo = { class: "fixed inset-0 flex items-center justify-center" }, mo = { class: "w-48 h-48 bg-black/90 rounded-lg flex flex-col items-center justify-center shadow-md" }, go = {
  key: 0,
  class: "pt-4 text-white/90 text-center"
}, es = /* @__PURE__ */ K({
  __name: "BlockingLoader",
  props: {
    blocking: { type: Boolean },
    blockingLabel: {}
  },
  setup(e) {
    return (t, n) => {
      const r = re("SvgIcon");
      return L(), ne(H(Dt), {
        show: t.blocking,
        as: "template"
      }, {
        default: W(() => [
          B(H(an), null, {
            default: W(() => [
              B(In, {
                visible: "",
                class: "opacity-30"
              }),
              B(H(Pt), {
                as: "template",
                enter: "duration-200 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "motion-reduce:transition-none opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "motion-reduce:transition-none opacity-0 scale-95"
              }, {
                default: W(() => [
                  z("div", vo, [
                    z("div", mo, [
                      B(r, {
                        name: "loader",
                        class: "animate-spin w-16 h-16 text-white/90"
                      }),
                      typeof t.blockingLabel == "string" ? (L(), V("p", go, le(t.blockingLabel), 1)) : De("", !0),
                      n[0] || (n[0] = z("button", { class: "opacity-0 w-0 h-0" }, null, -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
}), ho = /* @__PURE__ */ K({
  __name: "HalfSheet",
  props: {
    visible: { type: Boolean },
    content: {}
  },
  emits: ["close"],
  setup(e) {
    return (t, n) => (L(), ne(H(Dt), {
      show: t.visible,
      as: "template"
    }, {
      default: W(() => [
        B(H(an), {
          onClose: n[2] || (n[2] = (r) => t.$emit("close"))
        }, {
          default: W(() => [
            B(In, {
              visible: "",
              onClick: n[0] || (n[0] = $t((r) => t.$emit("close"), ["self"]))
            }),
            B(H(Pt), {
              as: "template",
              enter: "duration-200 ease-out",
              "enter-from": "translate-y-full sm:translate-y-0 sm:translate-x-full",
              "enter-to": "motion-reduce:transition-none translate-y-0 sm:translate-x-0",
              leave: "duration-200 ease-in",
              "leave-from": "translate-y-0 sm:translate-y-0 sm:translate-x-full",
              "leave-to": "motion-reduce:transition-none translate-y-full sm:translate-y-0 sm:translate-x-full"
            }, {
              default: W(() => [
                B(H(Xn), {
                  class: Oe(["half-sheet absolute bottom-0 left-0 right-0 px-4 py-8 bg-white overflow-y-auto rounded-t-2xl sm:rounded-none z-10 sm:top-0 sm:left-auto sm:w-96", t.content && "noPadding" in t.content.props && t.content.props.noPadding && "p-0!"])
                }, {
                  default: W(() => {
                    var r;
                    return [
                      B(Dr, {
                        id: "sheet-close-button",
                        "data-gtm-action": "close sheet",
                        class: Oe(["absolute right-3 top-3 text-gray-600 z-10", t.content && "hideCloseButton" in t.content.props && t.content.props.hideCloseButton && "hidden"]),
                        onClick: n[1] || (n[1] = (a) => t.$emit("close"))
                      }, null, 8, ["class"]),
                      t.content ? (L(), ne(nn(t.content.component), rn({ key: 0 }, t.content.props, jn((r = t.content) == null ? void 0 : r.events)), null, 16)) : De("", !0)
                    ];
                  }),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]));
  }
}), ts = /* @__PURE__ */ Ce(ho, [["__scopeId", "data-v-fabf08f3"]]), po = { class: "fixed left-0 top-0 w-full h-full overflow-y-auto overflow-x-hidden outline-hidden p-4" }, _o = { class: "relative flex-center min-h-[calc(100%-1rem)]" }, ns = /* @__PURE__ */ K({
  __name: "ModalDialog",
  props: {
    visible: { type: Boolean },
    content: {}
  },
  setup(e) {
    return (t, n) => (L(), ne(H(Dt), {
      show: t.visible,
      as: "template"
    }, {
      default: W(() => [
        B(H(an), {
          onClose: n[2] || (n[2] = (r) => t.$emit("close"))
        }, {
          default: W(() => [
            B(In, {
              visible: "",
              onClick: n[0] || (n[0] = $t((r) => t.$emit("close"), ["self"]))
            }),
            z("div", po, [
              z("div", _o, [
                B(H(Pt), {
                  as: "template",
                  enter: "duration-200 ease-out",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "motion-reduce:transition-none opacity-100 scale-100",
                  leave: "duration-200 ease-in",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "motion-reduce:transition-none opacity-0 scale-95"
                }, {
                  default: W(() => [
                    B(H(Xn), {
                      "data-testid": "modal-dialog-panel",
                      class: "modal min-w-[92vw] max-w-[92vw] sm:min-w-[320px] sm:max-w-[500px] w-full relative px-4 py-6 bg-white rounded-2xl z-10"
                    }, {
                      default: W(() => {
                        var r;
                        return [
                          B(Dr, {
                            class: "absolute right-2 top-2 text-gray-800 hover:text-black rounded-full z-10",
                            onClick: n[1] || (n[1] = (a) => t.$emit("close"))
                          }),
                          t.content ? (L(), ne(nn(t.content.component), rn({ key: 0 }, t.content.props, jn((r = t.content) == null ? void 0 : r.events)), null, 16)) : De("", !0)
                        ];
                      }),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]));
  }
}), Eo = ["aria-label"], yo = { class: "flex items-center gap-0.5 text-junip-star-color" }, bo = {
  key: 0,
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  class: "h-3 w-3"
}, Ao = ["id"], So = ["width"], wo = ["mask"], To = {
  key: 0,
  class: "rating-text text-xs"
}, rs = /* @__PURE__ */ K({
  __name: "DynamicStars",
  props: {
    rating: {},
    count: {}
  },
  setup(e) {
    const t = e, n = pe(() => Math.floor(t.rating)), r = pe(() => 5 - Math.ceil(t.rating)), a = pe(() => t.rating - Math.floor(t.rating)), o = pe(() => t.rating && t.count ? `${t.rating.toFixed(2)} stars, ${t.count} reviews` : "no rating");
    return (i, u) => {
      const f = re("SvgIcon");
      return L(), V("div", {
        role: "img",
        class: Oe(["product-rating flex items-center gap-2 h-5", i.rating || i.count ? "" : "opacity-50"]),
        "aria-label": o.value
      }, [
        z("div", yo, [
          (L(!0), V(_e, null, Ze(n.value, (s) => (L(), ne(f, {
            key: s,
            role: "img",
            name: "star",
            class: "h-3 w-3"
          }))), 128)),
          a.value > 0 ? (L(), V("svg", bo, [
            u[0] || (u[0] = z("title", null, "Mask star", -1)),
            z("defs", null, [
              z("mask", {
                id: `star-mask-${i.rating}`
              }, [
                z("rect", {
                  x: "3",
                  y: "0",
                  width: 10 * a.value,
                  height: "16",
                  fill: "white"
                }, null, 8, So)
              ], 8, Ao)
            ]),
            u[1] || (u[1] = z("path", {
              d: "M3.2,16C3.031,16 2.867,15.947 2.73,15.848C2.489,15.674 2.365,15.38 2.408,15.086L3.151,9.883L0.234,6.966C0.022,6.754 -0.054,6.441 0.038,6.156C0.129,5.871 0.373,5.661 0.668,5.612L5.066,4.878L7.284,0.443C7.421,0.172 7.696,0 8,0C8.305,0.002 8.586,0.176 8.719,0.45L10.842,4.812L15.34,5.613C15.633,5.665 15.873,5.876 15.963,6.16C16.053,6.445 15.977,6.755 15.765,6.966L12.848,9.883L13.592,15.086C13.634,15.382 13.508,15.676 13.265,15.85C13.023,16.024 12.704,16.049 12.438,15.914L8,13.694L3.554,15.917C3.444,15.972 3.323,16 3.2,16ZM4.71,13.116L8,11.458L11.286,13.088L10.726,9.176L12.724,7.179L9.49,6.603L8,3.512L6.4,6.683L3.297,7.201L5.272,9.176L4.71,13.116Z",
              fill: "currentColor"
            }, null, -1)),
            z("path", {
              d: "M3.2,16C3.031,16 2.867,15.947 2.73,15.848C2.489,15.674 2.365,15.38 2.408,15.086L3.151,9.883L0.234,6.966C0.022,6.754 -0.054,6.441 0.038,6.156C0.129,5.871 0.373,5.661 0.668,5.612L5.066,4.878L7.284,0.443C7.421,0.172 7.696,0 8,0C8.305,0.002 8.586,0.176 8.719,0.45L10.842,4.812L15.34,5.613C15.633,5.665 15.873,5.876 15.963,6.16C16.053,6.445 15.977,6.755 15.765,6.966L12.848,9.883L13.592,15.086C13.634,15.382 13.508,15.676 13.265,15.85C13.023,16.024 12.704,16.049 12.438,15.914L8,13.694L3.554,15.917C3.444,15.972 3.323,16 3.2,16Z",
              fill: "currentColor",
              mask: `url(#star-mask-${i.rating})`
            }, null, 8, wo)
          ])) : De("", !0),
          (L(!0), V(_e, null, Ze(r.value, (s) => (L(), ne(f, {
            key: s,
            role: "img",
            name: "star-outline",
            class: "h-3 w-3"
          }))), 128))
        ]),
        i.rating && i.count ? (L(), V("span", To, le(Math.round(i.rating * 100) / 100) + " (" + le(i.count) + ") ", 1)) : De("", !0)
      ], 10, Eo);
    };
  }
}), Io = ["aria-label"], Lo = ["data-rating", "onMouseenter", "onClick"], as = /* @__PURE__ */ K({
  __name: "InteractiveStars",
  props: {
    modelValue: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, r = e, a = Xe(), o = Xe(r.modelValue), i = Xe(), u = pe(() => i.value || Number(r.modelValue)), f = pe(() => r.modelValue ? `${r.modelValue.toFixed(2)} stars` : "no rating");
    let s;
    const l = (d) => {
      r.disabled || (clearTimeout(s), i.value = d);
    }, _ = () => {
      s = setTimeout(() => i.value = void 0, 50);
    }, m = (d) => {
      r.disabled || (o.value = d, n("update:modelValue", d));
    };
    class h {
      constructor() {
        $n(this, "el");
      }
      setElement(g) {
        this.el = g;
      }
      getTouchRating(g) {
        const E = g.changedTouches[0];
        if (!this.el || !E)
          return o.value;
        const v = this.el.getBoundingClientRect(), p = (E.clientX - v.x) / v.width;
        return Math.min(Math.max(1, Math.ceil(5 * p)), 5);
      }
      handleTouch(g) {
        i.value = this.getTouchRating(g);
      }
      handleTouchEnd(g) {
        this.handleTouch(g), i.value && m(i.value);
      }
    }
    const c = new h();
    return Wn(() => c.setElement(a.value)), (d, g) => {
      const E = re("SvgIcon");
      return L(), V("div", {
        ref_key: "el",
        ref: a,
        role: "img",
        "aria-label": f.value,
        class: "row-of-stars flex-center gap-0.5 pointer-events-none",
        onTouchstart: g[0] || (g[0] = //@ts-ignore
        (...v) => H(c).handleTouch && H(c).handleTouch(...v)),
        onTouchmove: g[1] || (g[1] = //@ts-ignore
        (...v) => H(c).handleTouch && H(c).handleTouch(...v)),
        onTouchend: g[2] || (g[2] = //@ts-ignore
        (...v) => H(c).handleTouchEnd && H(c).handleTouchEnd(...v))
      }, [
        (L(), V(_e, null, Ze(5, (v) => z("button", {
          key: v,
          "data-rating": v,
          class: "pointer-events-auto",
          onMouseenter: (p) => l(v),
          onMouseleave: _,
          onClick: (p) => m(v)
        }, [
          B(E, {
            role: "img",
            name: v <= u.value ? "rating" : "rating-outline",
            class: Oe([v <= u.value ? "text-junip-star-color" : "text-gray-300", "interactive-star pointer-events-none"])
          }, null, 8, ["name", "class"])
        ], 40, Lo)), 64))
      ], 40, Io);
    };
  }
}), $o = { class: "z-30 relative w-full" }, Co = { key: 0 }, Ro = {
  key: 1,
  class: "text-gray-500"
}, No = { class: "pointer-events-none absolute inset-y-0 right-0 flex-center pr-4" }, Oo = /* @__PURE__ */ K({
  __name: "ListBoxSelect",
  props: /* @__PURE__ */ Hr({
    options: {},
    placeholder: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Wr(e, "modelValue");
    return (n, r) => {
      const a = re("SvgIcon");
      return L(), ne(H(Zr), {
        modelValue: t.value,
        "onUpdate:modelValue": r[0] || (r[0] = (o) => t.value = o)
      }, {
        default: W(() => [
          z("div", $o, [
            B(H(Jr), { class: "hui-dropdown-button w-full" }, {
              default: W(() => [
                t.value ? (L(), V("span", Co, [
                  ce(n.$slots, "option", Yr(jr(t.value)), () => [
                    Ie(le(t.value.id), 1)
                  ], !0)
                ])) : (L(), V("i", Ro, le(n.placeholder || "Select an option"), 1)),
                z("span", No, [
                  B(a, {
                    name: "chevron-down",
                    class: "w-3 h-3 text-gray-400"
                  })
                ])
              ]),
              _: 3
            }),
            B(Xr, {
              "leave-active-class": "transition duration-100 ease-in",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: W(() => [
                B(H(Qr), { class: "hui-dropdown-list right-0 divide-y" }, {
                  default: W(() => [
                    (L(!0), V(_e, null, Ze(n.options, (o) => (L(), ne(H(ea), {
                      key: o.id,
                      value: o,
                      as: "template"
                    }, {
                      default: W(({ active: i }) => [
                        z("li", {
                          class: Oe(["flex center", i && "active"])
                        }, [
                          ce(n.$slots, "option", rn({ ref_for: !0 }, o), () => [
                            Ie(le(o), 1)
                          ], !0)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ])
        ]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
}), is = /* @__PURE__ */ Ce(Oo, [["__scopeId", "data-v-6ce1752f"]]), Do = { class: "plus-minus-input flex" }, Po = ["disabled"], ko = ["value", "disabled", "max", "min"], Mo = ["disabled"], xo = /* @__PURE__ */ K({
  __name: "PlusMinusInput",
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    increaseDisabled: { type: Boolean },
    min: { default: 0 },
    max: { default: 1 / 0 }
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (t, n) => {
      const r = re("SvgIcon");
      return L(), V("div", Do, [
        z("button", {
          class: "plus-minus-button rounded-l-full",
          "data-gtm-action": "minus input",
          "aria-label": "minus",
          disabled: t.modelValue <= t.min,
          onClick: n[0] || (n[0] = $t((a) => t.$emit("update:modelValue", t.modelValue - 1), ["prevent", "stop"]))
        }, [
          B(r, {
            name: "minus",
            class: "w-4 h-4 pointer-events-none"
          })
        ], 8, Po),
        z("input", {
          readonly: "",
          "aria-label": "current quantity",
          value: t.modelValue,
          disabled: t.disabled,
          type: "text",
          max: t.max,
          min: t.min,
          size: "4",
          class: "w-full text-center text-base bg-gray-100 text-gray-900 outline-hidden font-semibold cursor-default focus-none border-none rounded-none select-none disabled:text-gray-400",
          onChange: n[1] || (n[1] = (a) => t.$emit("update:modelValue", Number(a.target.value)))
        }, null, 40, ko),
        z("button", {
          class: "plus-minus-button rounded-r-full",
          "data-gtm-action": "plus input",
          "aria-label": "plus",
          disabled: t.disabled || t.increaseDisabled || t.modelValue >= t.max,
          onClick: n[2] || (n[2] = $t((a) => t.$emit("update:modelValue", t.modelValue + 1), ["prevent", "stop"]))
        }, [
          B(r, {
            name: "plus",
            class: "w-4 h-4 pointer-events-none"
          })
        ], 8, Mo)
      ]);
    };
  }
}), os = /* @__PURE__ */ Ce(xo, [["__scopeId", "data-v-7ee78216"]]), ss = {
  async install(e) {
    e.component("LoaderButton", uo), e.component("ResponsiveImage", st), e.component("SectionLoader", Ci), e.component("SvgIcon", Oi);
  }
};
export {
  es as BlockingLoader,
  zo as BundleSelectionProduct,
  Zo as Button,
  Uo as CheckmarkCallout,
  Dr as CloseButton,
  In as DialogOverlay,
  Jo as DisclosureButton,
  rs as DynamicStars,
  ts as HalfSheet,
  Go as ImageSlider,
  as as InteractiveStars,
  is as ListBoxSelect,
  uo as LoaderButton,
  ns as ModalDialog,
  Wo as OrderStatusTag,
  os as PlusMinusInput,
  Yo as ProductNewFlavorTag,
  Ko as ProductNutritionModal,
  jo as ProductRatingImage,
  qo as ProductReviewsModal,
  Xo as ProductTagIcons,
  Qo as RemoveButton,
  st as ResponsiveImage,
  Ci as SectionLoader,
  Oi as SvgIcon,
  Ho as Toast,
  ss as globalComponentsPlugin
};
